import { NgModule } from '@angular/core';
import { BassScaResetPasswordComponent } from './bass-sca-reset-password.component';
import { BassScaTokenVerificationFailedComponent } from './components/bass-sca-token-verification-failed/bass-sca-token-verification-failed.component';
import { BassScaupdatePasswordComponent } from './components/bass-sca-update-password/bass-sca-update-password.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CommonItemsModule } from 'src/common-items/common-items.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BassScaResetPasswordService } from './services/reset-password.service';
import { BassScaResetPasswordApiService } from './services/reset-password-api.service';
import { BassScaSucessPageComponent } from './components/bass-sca-sucess-page/bass-sca-sucess-page.component';

@NgModule({
  declarations: [
    BassScaResetPasswordComponent,
    BassScaTokenVerificationFailedComponent,
    BassScaupdatePasswordComponent,
    BassScaSucessPageComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CommonItemsModule
  ],
  providers: [BassScaResetPasswordService, BassScaResetPasswordApiService]
})
export class BassScaResetPasswordModule { }